import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as theme from "../theme";
import Modal from "react-modal";
import PerfectScrollbar from "react-perfect-scrollbar";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import CheckCircleOutlineOutlinedIcon from "@material-ui/icons/CheckCircleOutlineOutlined";
import RadioButtonUncheckedOutlinedIcon from "@material-ui/icons/RadioButtonUncheckedOutlined";
import AddIcon from "@material-ui/icons/Add";
import ActionButton from "../general/ActionButton";
import {
  getDefaultInsurersList,
  getDefaultInsurersListSelector,
} from "../store/brokerage";
import {
  toggleAddInsurerModal,
  addInsurer,
  updateInsurer,
  getAddInsurerStatus,
  getSelectedInsurerDetails,
  getInsurerOptions,
  getInsurerOptionsList,
} from "../store/insurers";
import { getVerticalList, loadverticals } from "../store/verticals";
import { toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import { Redirect } from "react-router-dom";
import Select from "react-dropdown-select";
import { useNavigate } from "react-router-dom";

const BrokerageInsurerAdminDashboard = () => {
  return <BrokerageSuperAdminDashboardPane></BrokerageSuperAdminDashboardPane>;
};

const BrokerageSuperAdminDashboardPane = () => {
  const [insurer, setInsurer] = useState(null);
  const dispatch = useDispatch();
  let addInsurerModalState = useSelector(getAddInsurerStatus);
  useEffect(() => {
    dispatch(getDefaultInsurersList());
    dispatch(getInsurerOptions());
  }, []);
  let insContacts = useSelector(getDefaultInsurersListSelector);

  // On operation selected
  const onChangeHandle = (value) => {
    // dispatch(brokerageSelected(value[0].code));
  };
  const onAddInsurerClickHandle = (value) => {
    dispatch(toggleAddInsurerModal(value));
  };
  return (
    <div
      style={{
        margin: "3.5rem",
      }}
    >
      <div>
        {/* <h5 className="px-2" style={{
          fontFamily: "GibsonSemiBd",
          justifyContent: "center",
          fontSize: "1.2vw",
        }}>You can customize the e-mail contacts and names that your team sees for insurers when sending to market.</h5> */}
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            paddingLeft: "5%",
            paddingRight: "5%",
          }}
        >
          {}

          <div
            style={{
              width: "100%",
              display: "flex",
            }}
          >
            <div style={{ width: "100%" }}>
              <Button
                style={{
                  color: "white",
                  fontFamily: "GibsonRegular",
                  fontSize: 14,
                  backgroundColor: theme.COLORS.secondary_orange,
                  marginTop: 10,
                  marginLeft: "40%",
                  border: 0,
                  width: "10vw",
                  letterSpacing: 1,
                }}
                onClick={() => {
                  setInsurer(null);
                  onAddInsurerClickHandle(true);
                }}
              >
                Add New Insurer
              </Button>
            </div>
          </div>
          <br />
        </div>
        <InsurerContactItems setInsurer={setInsurer} />
      </div>
      <Modal
        size="md"
        isOpen={addInsurerModalState}
        ariaHideApp={false}
        shouldCloseOnEsc={false}
        centered
        style={{
          overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: theme.COLORS.rgba_primary_navyblue,
          },
          content: {
            height: "85vh",
            width: "70vw",
            position: "absolute",
            top: "5vh",
            left: "10vw",
            background: "#eef3f6",
            WebkitOverflowScrolling: "touch",
            border: "8px solid " + theme.COLORS.primary_navyblue,
            borderRadius: "20px",
            padding: 0,
            overflow: "hidden",
          },
        }}
      >
        <AddInsurer insurer={insurer} />
      </Modal>
    </div>
  );
};

const AddInsurer = (props) => {
  let options = useSelector(getInsurerOptionsList);
  const [insurer, setInsurer] = useState(props.insurer);
  const [newEmail, setNewEmail] = useState(null);
  const [newDescription, setNewDescription] = useState(null);
  if (!insurer)
    setInsurer({
      actualname:null,
      name: null,
      code: null,
      emails: null,
      starrating: null,
      description: null,
      quotesby: null,
      markettype: null,
      isactive: true,
      otherinfo: null,
      verticalids: null,
      bindtype: null,
      verticalid: null,
      insurer_is_type1: null,
    });
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadverticals());
  }, []);

  let verticals = useSelector(getVerticalList);

  const onAddButtonClick = () => {
    let data = {
      insurer: {
        name: insurer?.name,
        code: insurer?.name,
        actualname:insurer?.actualname,
        emails: insurer?.emails,
        starrating: insurer?.starrating,
        description: insurer?.description,
        quotesby: insurer?.quotesby,
        markettype: insurer?.markettype,
        isactive: true,
        otherinfo: insurer?.otherinfo,
        verticalids: insurer?.verticalids,
        bindtype: insurer?.bindtype,
        verticalid: insurer?.verticalid,
        insurer_is_type1:
          typeof insurer?.insurer_is_type1 == "boolean"
            ? insurer?.insurer_is_type1
            : insurer?.markettype,
      },
    };
    dispatch(addInsurer(data)).then(
      setTimeout(() => {
        dispatch(getDefaultInsurersList());
        // Array.isArray(updateErrors) && !updateErrors.length ? toast.success("Branch Added Successfully") : toast(updateErrors);
      }, 100)
    );
    dispatch(toggleAddInsurerModal(false));
  };

  const onUpdateButtonClick = () => {
    let data = {
      insurer: {
        actualname:insurer?.actualname,
        name: insurer?.name,
        code: insurer?.code,
        emails: insurer?.emails,
        starrating: insurer?.starrating,
        description: insurer?.description,
        quotesby: insurer?.quotesby,
        isactive: insurer?.isactive,
        markettype: insurer?.markettype,
        otherinfo: insurer?.otherinfo,
        verticalids: insurer?.verticalids,
        bindtype: insurer?.bindtype,
        verticalid: insurer?.verticalid,
        insurer_is_type1:
          typeof insurer?.insurer_is_type1 == "boolean"
            ? insurer?.insurer_is_type1
            : insurer?.markettype,
      },
    };
    dispatch(updateInsurer(data)).then(
      setTimeout(() => {
        dispatch(getDefaultInsurersList());
        // Array.isArray(updateErrors) && !updateErrors.length ? toast.success("Branch Added Successfully") : toast(updateErrors);
      }, 300)
    );
    dispatch(toggleAddInsurerModal(false));
  };

  const getVerticalSelectedValues = (value) => {
    let arr = [];
    for (let val in value) {
      let label = "";
      for (let vert of verticals) {
        if (vert.id == value[val]) label = vert.name["en"];
      }
      arr.push({ label: label, value: value[val] });
    }
    return arr;
  };

  const onCancelButtonClick = (value) => {
    dispatch(toggleAddInsurerModal(value));
  };

  const onVerticalChangeHandle = (value) => {
    var verts = [];
    value.forEach((v) => {
      verts.push(v.value);
    });
    setInsurer({
      actualname: insurer?.actualname ? insurer?.actualname : insurer?.name,
      name: insurer?.name,
      code: insurer?.code,
      emails: insurer?.emails,
      starrating: insurer?.starrating,
      description: insurer?.description,
      quotesby: insurer?.quotesby,
      markettype: insurer?.markettype,
      isactive: true,
      otherinfo: insurer?.otherinfo,
      verticalids: verts,
      bindtype: insurer?.bindtype,
      verticalid: insurer?.verticalid,
      insurer_is_type1:
        typeof insurer?.insurer_is_type1 == "boolean"
          ? insurer?.insurer_is_type1
          : insurer?.markettype,
    });
  };

  const onSingleVerticalChangeHandle = (value) => {
    setInsurer({
      actualname: insurer?.actualname ? insurer?.actualname : insurer?.name,
      name: insurer?.name,
      code: insurer?.code,
      emails: insurer?.emails,
      starrating: insurer?.starrating,
      description: insurer?.description,
      quotesby: insurer?.quotesby,
      markettype: insurer?.markettype,
      isactive: true,
      otherinfo: insurer?.otherinfo,
      verticalids: insurer?.verticalids,
      bindtype: insurer?.bindtype,
      verticalid: value[0].value,
      insurer_is_type1:
        typeof insurer?.insurer_is_type1 == "boolean"
          ? insurer?.insurer_is_type1
          : insurer?.markettype,
    });
  };

  const onQuotesByChangeHandle = (value) => {
    setInsurer({
      actualname: insurer?.actualname ? insurer?.actualname : insurer?.name,
      name: insurer?.name,
      code: insurer?.code,
      emails: insurer?.emails,
      starrating: insurer?.starrating,
      description: insurer?.description,
      quotesby: value[0]?.value ? value[0].value : value,
      markettype: insurer?.markettype,
      isactive: true,
      otherinfo: insurer?.otherinfo,
      verticalids: insurer?.verticalids,
      bindtype: insurer?.bindtype,
      verticalid: insurer?.verticalid,
      insurer_is_type1:
        typeof insurer?.insurer_is_type1 == "boolean"
          ? insurer?.insurer_is_type1
          : insurer?.markettype,
    });
  };
  const onMarketTypeChangeHandle = (value) => {
    setInsurer({
      actualname: insurer?.actualname ? insurer?.actualname : insurer?.name,
      name: insurer?.name,
      code: insurer?.code,
      emails: insurer?.emails,
      starrating: insurer?.starrating,
      description: insurer?.description,
      quotesby: insurer?.quotesby,
      markettype: value[0] ? value[0].value : value,
      isactive: true,
      otherinfo: insurer?.otherinfo,
      verticalids: insurer?.verticalids,
      bindtype: insurer?.bindtype,
      verticalid: insurer?.verticalid,
      insurer_is_type1: value[0] ? value[0].value : value,
    });
  };
  const onBindTypeChangeHandle = (value) => {
    setInsurer({
      actualname: insurer?.actualname ? insurer?.actualname : insurer?.name,
      name: insurer?.name,
      code: insurer?.code,
      emails: insurer?.emails,
      starrating: insurer?.starrating,
      description: insurer?.description,
      quotesby: insurer?.quotesby,
      markettype: insurer?.markettype,
      isactive: true,
      otherinfo: insurer?.otherinfo,
      verticalids: insurer?.verticalids,
      bindtype: value[0]?.value ? value[0].value : value,
      insurer_is_type1:
        typeof insurer?.insurer_is_type1 == "boolean"
          ? insurer?.insurer_is_type1
          : insurer?.markettype,
    });
  };
  const onBindTypeChangeHandleQR = (value) => {
    const otherinfo = { ...insurer.otherinfo, bindtypeQR: value[0]?.value ? value[0].value : value };
    setInsurer((prevInsurer) => ({
      ...prevInsurer,
      otherinfo 
    })) ;
  }

  let bindTypeOptions = options?.bindtypeoptions;
  let marketTypeOptions = options?.markettypeoptions;
  let quotesByOptions = options?.quotesbyoptions;
  let selectedInsurerBindTypeLabel = "";
  let selectedInsurerBindTypeQRLabel = ""
  let selectedMarketTypeLabel = "";
  for (let o of bindTypeOptions) {
    if (insurer && o.bindtypecode == insurer.bindtype)
      selectedInsurerBindTypeLabel = o.name;
    if(insurer && o.bindtypecode == insurer?.otherinfo?.bindtypeQR){
      selectedInsurerBindTypeQRLabel = o.name;
    }
  }
  if (
    insurer?.insurer_is_type1 != null &&
    insurer?.insurer_is_type1 != undefined &&
    Object.values(marketTypeOptions).includes(insurer.insurer_is_type1)
  ) {
    selectedMarketTypeLabel = Object.keys(marketTypeOptions)[
      Object.values(marketTypeOptions).indexOf(insurer.insurer_is_type1)
    ];
  }
  return (
    <PerfectScrollbar>
      <div style={{ verticalAlign: "middle" }}>
        <form className="m-4">
          <h3
            className="text-center m-3"
            style={{
              fontFamily: "GibsonSemiBd",
              justifyContent: "center",
              fontSize: "1.2vw",
            }}
          >
            {insurer?.code ? "Edit Insurer" : "Add New Insurer"}
          </h3>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label className="col-sm-4 col-form-label">Insurer Name</label>
            <div className="col-sm-8">
              <input
                className="form-control"
                id="txtName"
                placeholder="Enter Insurer Name"
                onChange={(event) => {
                  setInsurer({
                    actualname: event.target.value,
                    name: insurer?.name,
                    code: insurer?.code,
                    emails: insurer?.emails,
                    starrating: insurer?.starrating,
                    description: insurer?.description,
                    quotesby: insurer?.quotesby,
                    markettype: insurer?.markettype,
                    isactive: true,
                    otherinfo: insurer?.otherinfo,
                    verticalids: insurer?.verticalids,
                    bindtype: insurer?.bindtype,
                    verticalid: insurer?.verticalid,
                    insurer_is_type1:
                      typeof insurer?.insurer_is_type1 == "boolean"
                        ? insurer?.insurer_is_type1
                        : insurer?.markettype,
                  });
                }}
                defaultValue={insurer?.actualname}
              />
            </div>
          </div>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label className="col-sm-4 col-form-label">Product Name</label>
            <div className="col-sm-8">
              <input
                className="form-control"
                id="txtName"
                placeholder="Enter Product Name, ( source for brokeragecode ) "
                onChange={(event) => {
                  setInsurer({
                    actualname: insurer?.actualname ? insurer?.actualname : insurer?.name,
                    name: event.target.value,
                    code: insurer?.code,
                    emails: insurer?.emails,
                    starrating: insurer?.starrating,
                    description: insurer?.description,
                    quotesby: insurer?.quotesby,
                    markettype: insurer?.markettype,
                    isactive: true,
                    otherinfo: insurer?.otherinfo,
                    verticalids: insurer?.verticalids,
                    bindtype: insurer?.bindtype,
                    verticalid: insurer?.verticalid,
                    insurer_is_type1:
                      typeof insurer?.insurer_is_type1 == "boolean"
                        ? insurer?.insurer_is_type1
                        : insurer?.markettype,
                  });
                }}
                defaultValue={insurer?.name}
              />
            </div>
          </div>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label className="col-sm-4 col-form-label">Active</label>
            <div className="col-sm-8">
              <input
                className="form-control"
                id="chkActive"
                type="checkbox"
                onChange={(event) => {
                  setInsurer({
                    actualname: insurer?.actualname ? insurer?.actualname : insurer?.name,
                    name: insurer?.name,
                    code: insurer?.code,
                    emails: insurer?.emails,
                    starrating: insurer?.starrating,
                    description: insurer?.description,
                    quotesby: insurer?.quotesby,
                    markettype: insurer?.markettype,
                    isactive: event.target.checked,
                    otherinfo: insurer?.otherinfo,
                    verticalids: insurer?.verticalids,
                    bindtype: insurer?.bindtype,
                    verticalid: insurer?.verticalid,
                    insurer_is_type1:
                      typeof insurer?.insurer_is_type1 == "boolean"
                        ? insurer?.insurer_is_type1
                        : insurer?.markettype,
                  });
                }}
                checked={insurer?.isactive}
              />
            </div>
          </div>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label className="col-sm-4 col-form-label">Star Rating</label>
            <div className="col-sm-8">
              <input
                className="form-control"
                id="txtStarRating"
                type="number"
                placeholder="Enter Star Rating"
                onChange={(event) => {
                  setInsurer({
                    actualname: insurer?.actualname ? insurer?.actualname : insurer?.name,
                    name: insurer?.name,
                    code: insurer?.code,
                    emails: insurer?.emails,
                    starrating: event.target.value,
                    description: insurer?.description,
                    quotesby: insurer?.quotesby,
                    markettype: insurer?.markettype,
                    isactive: true,
                    otherinfo: insurer?.otherinfo,
                    verticalids: insurer?.verticalids,
                    bindtype: insurer?.bindtype,
                    verticalid: insurer?.verticalid,
                    insurer_is_type1:
                      typeof insurer?.insurer_is_type1 == "boolean"
                        ? insurer?.insurer_is_type1
                        : insurer?.markettype,
                  });
                }}
                defaultValue={insurer?.starrating}
              />
            </div>
          </div>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label className="col-sm-4 col-form-label">Other Info</label>
            <div className="col-sm-8">
              <input
                className="form-control"
                id="txtOtherInfo"
                placeholder="Enter Other Info"
                onChange={(event) => {
                  setInsurer({
                    actualname: insurer?.actualname ? insurer?.actualname : insurer?.name,
                    name: insurer?.name,
                    code: insurer?.code,
                    emails: insurer?.emails,
                    starrating: insurer?.starrating,
                    description: insurer?.description,
                    quotesby: insurer?.quotesby,
                    markettype: insurer?.markettype,
                    isactive: true,
                    otherinfo: event.target.value,
                    verticalids: insurer?.verticalids,
                    bindtype: insurer?.bindtype,
                    verticalid: insurer?.verticalid,
                    insurer_is_type1:
                      typeof insurer?.insurer_is_type1 == "boolean"
                        ? insurer?.insurer_is_type1
                        : insurer?.markettype,
                  });
                }}
                defaultValue={insurer?.otherinfo}
              />
            </div>
          </div>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label className="col-sm-4 col-form-label">Quotes By</label>
            <div className="col-sm-8">
              <div style={{ width: "100%" }}>
                <Select
                  placeholder={
                    insurer?.quotesby ? insurer?.quotesby : "Enter quotes by"
                  }
                  color={theme.COLORS.primary_navyblue}
                  searchable={true}
                  onChange={(values) => onQuotesByChangeHandle(values)}
                  values={
                    insurer?.quotesby
                      ? [{ label: insurer?.quotesby, value: insurer?.quotesby }]
                      : []
                  }
                  options={
                    quotesByOptions
                      ? quotesByOptions.map((x) => ({
                          value: x.toLowerCase(),
                          label: x,
                        }))
                      : []
                  }
                  style={{
                    width: "100%",
                    height: "5vh",
                    fontSize: "1.9vmin",
                    border: "5px solid white",
                    borderRadius: 15,
                    fontFamily: "GibsonRegular",
                  }}
                  dropdownHeight={"50vh"}
                />
              </div>
            </div>
          </div>
          {insurer?.quotesby && insurer?.quotesby == "inhouse" && (
            <div
              class="form-group row"
              style={{
                fontFamily: "GibsonRegular",
                justifyContent: "center",
                fontSize: "1vw",
              }}
            >
              <label for="lblVerticalId" class="col-sm-4 col-form-label">
                Vertical Id
              </label>
              <div class="col-sm-8">
                <Select
                  placeholder={"Enter a vertical"}
                  color={theme.COLORS.primary_navyblue}
                  searchable={true}
                  onChange={(values) => onSingleVerticalChangeHandle(values)}
                  values={getVerticalSelectedValues([insurer?.verticalid])}
                  options={verticals.map(({ id, name }) => ({
                    value: id,
                    label: name["en"],
                  }))}
                  style={{
                    width: "100%",
                    height: "5vh",
                    fontSize: "1.9vmin",
                    border: "5px solid white",
                    borderRadius: 15,
                    fontFamily: "GibsonRegular",
                  }}
                  dropdownHeight={"50vh"}
                />
              </div>
            </div>
          )}
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label className="col-sm-4 col-form-label">Bind Type</label>
            <div className="col-sm-8">
              <div style={{ width: "100%" }}>
                <Select
                  placeholder={
                    insurer?.bindtype ? insurer?.bindtype : "Enter a bind type"
                  }
                  color={theme.COLORS.primary_navyblue}
                  searchable={true}
                  onChange={(values) => onBindTypeChangeHandle(values)}
                  values={
                    insurer?.bindtype
                      ? [
                          {
                            label: selectedInsurerBindTypeLabel,
                            value: insurer?.bindtype,
                          },
                        ]
                      : []
                  }
                  options={
                    bindTypeOptions
                      ? bindTypeOptions.map((x) => ({
                          value: x.bindtypecode,
                          label: x.name,
                        }))
                      : []
                  }
                  style={{
                    width: "100%",
                    height: "5vh",
                    fontSize: "1.9vmin",
                    border: "5px solid white",
                    borderRadius: 15,
                    fontFamily: "GibsonRegular",
                  }}
                  dropdownHeight={"50vh"}
                />
              </div>
            </div>
          </div>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label className="col-sm-4 col-form-label">Bind Type During Quote Refer</label>
            <div className="col-sm-8">
              <div style={{ width: "100%" }}>
                <Select
                  placeholder={
                    insurer?.bindtype ? insurer?.bindtype : "Enter a bind type"
                  }
                  color={theme.COLORS.primary_navyblue}
                  searchable={true}
                  onChange={(values) => onBindTypeChangeHandleQR(values)}
                  values={
                    insurer?.otherinfo?.bindtypeQR
                      ? [
                          {
                            label: selectedInsurerBindTypeQRLabel,
                            value: insurer?.otherinfo?.bindtypeQR,
                          },
                        ]
                      : []
                  }
                  options={
                    bindTypeOptions
                      ? bindTypeOptions.map((x) => ({
                          value: x.bindtypecode,
                          label: x.name,
                        }))
                      : []
                  }
                  style={{
                    width: "100%",
                    height: "5vh",
                    fontSize: "1.9vmin",
                    border: "5px solid white",
                    borderRadius: 15,
                    fontFamily: "GibsonRegular",
                  }}
                  dropdownHeight={"50vh"}
                />
              </div>
            </div>
          </div>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label className="col-sm-4 col-form-label">Market Type</label>
            <div className="col-sm-8">
              <div style={{ width: "100%" }}>
                <Select
                  placeholder={
                    insurer?.insurer_is_type1
                      ? insurer?.insurer_is_type1
                      : "Enter a market type"
                  }
                  color={theme.COLORS.primary_navyblue}
                  searchable={true}
                  onChange={(values) => onMarketTypeChangeHandle(values)}
                  values={
                    typeof insurer?.insurer_is_type1 == "boolean"
                      ? [
                          {
                            label: selectedMarketTypeLabel,
                            value: insurer?.insurer_is_type1,
                          },
                        ]
                      : []
                  }
                  options={
                    marketTypeOptions
                      ? Object.keys(marketTypeOptions).map((x) => ({
                          value: marketTypeOptions[x],
                          label: x,
                        }))
                      : []
                  }
                  style={{
                    width: "100%",
                    height: "5vh",
                    fontSize: "1.9vmin",
                    border: "5px solid white",
                    borderRadius: 15,
                    fontFamily: "GibsonRegular",
                  }}
                  dropdownHeight={"50vh"}
                />
              </div>
            </div>
          </div>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label className="col-sm-4 col-form-label">Description</label>
            <div className="col-sm-8">
              <input
                className="form-control"
                id="txtDescription"
                placeholder="Enter Description"
                onChange={(event) => {
                  setInsurer({
                    actualname: insurer?.actualname ? insurer?.actualname : insurer?.name,
                    name: insurer?.name,
                    code: insurer?.code,
                    emails: insurer?.emails,
                    starrating: insurer?.starrating,
                    description: event.target.value,
                    quotesby: insurer?.quotesby,
                    markettype: insurer?.markettype,
                    isactive: true,
                    otherinfo: insurer?.otherinfo,
                    verticalids: insurer?.verticalids,
                    bindtype: insurer?.bindtype,
                    verticalid: insurer?.verticalid,
                    insurer_is_type1:
                      typeof insurer?.insurer_is_type1 == "boolean"
                        ? insurer?.insurer_is_type1
                        : insurer?.markettype,
                  });
                }}
                defaultValue={insurer?.description}
              />
            </div>
          </div>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label className="col-sm-4 col-form-label">Vertical IDs</label>
            <div className="col-sm-8">
              {/* <input className="form-control" id="txtInsCodes" placeholder="Enter comma-separated insurer codes"
                onChange={(event) => { setInsCodes(event.target.value); }}
                defaultValue={props.insCodes} /> */}
              <div style={{ width: "100%" }}>
                <Select
                  multi
                  placeholder={
                    insurer?.verticalids
                      ? insurer?.verticalids.join(",")
                      : "Enter a vertical"
                  }
                  color={theme.COLORS.primary_navyblue}
                  searchable={true}
                  onChange={(values) => onVerticalChangeHandle(values)}
                  values={getVerticalSelectedValues(insurer?.verticalids)}
                  options={verticals.map(({ id, name }) => ({
                    value: id,
                    label: name["en"],
                  }))}
                  style={{
                    width: "100%",
                    height: "10vh",
                    fontSize: "1.9vmin",
                    border: "5px solid white",
                    borderRadius: 15,
                    fontFamily: "GibsonRegular",
                  }}
                  dropdownHeight={"50vh"}
                />
              </div>
            </div>
          </div>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label className="col-sm-4 col-form-label">Email</label>
            <div className="col-sm-8">
              <table className="table table-sm">
                <thead>
                  <tr>
                    <th scope="col">Email</th>
                    <th scope="col">Description</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr scope="row" className="thead-light">
                    <th scope="row">
                      <input
                        className="form-control col-sm"
                        onBlur={(event) => {
                          setNewEmail(event.target.value);
                        }}
                      ></input>
                    </th>
                    <th scope="row">
                      <input
                        className="form-control col-sm"
                        onBlur={(event) => {
                          setNewDescription(event.target.value);
                        }}
                      ></input>
                    </th>
                    <th
                      className="text-center bg-success"
                      style={{
                        width: "30px",
                        paddingTop: 10,
                        borderRadius: 5,
                        color: "white",
                      }}
                    >
                      <AddIcon
                        onClick={() => {
                          let emails = [];
                          if (!insurer?.emails)
                            emails.push({
                              email: newEmail,
                              description: newDescription,
                            });
                          else {
                            for (let e of insurer.emails) {
                              emails.push(e);
                            }
                            emails.push({
                              email: newEmail,
                              description: newDescription,
                            });
                          }
                          setInsurer({
                            actualname: insurer?.actualname ? insurer?.actualname : insurer?.name,
                            name: insurer?.name,
                            code: insurer?.code,
                            emails: emails,
                            starrating: insurer?.starrating,
                            description: insurer?.description,
                            quotesby: insurer?.quotesby,
                            markettype: insurer?.markettype,
                            isactive: true,
                            otherinfo: insurer?.otherinfo,
                            verticalids: insurer?.verticalids,
                            bindtype: insurer?.bindtype,
                            verticalid: insurer?.verticalid,
                            insurer_is_type1:
                              typeof insurer?.insurer_is_type1 == "boolean"
                                ? insurer?.insurer_is_type1
                                : insurer?.markettype,
                          });
                        }}
                      />
                    </th>
                  </tr>
                  {insurer?.emails ? (
                    insurer?.emails.map((item) => {
                      return (
                        <Fragment>
                          <tr scope="row" className="thead-light">
                            <th scope="row">{item.email}</th>
                            <th scope="row">{item.description}</th>
                            <th
                              className="text-center bg-danger"
                              style={{
                                width: "30px",
                                paddingTop: 5,
                                borderRadius: 5,
                                color: "white",
                              }}
                            >
                              <DeleteOutlineOutlinedIcon
                                onClick={() => {
                                  let emails = [];
                                  if (emails) {
                                    for (let e of insurer.emails) {
                                      if (e.email != item.email) emails.push(e);
                                    }
                                    setInsurer({
                                      actualname: insurer?.actualname ? insurer?.actualname : insurer?.name,
                                      name: insurer?.name,
                                      code: insurer?.code,
                                      emails: emails,
                                      starrating: insurer?.starrating,
                                      description: insurer?.description,
                                      quotesby: insurer?.quotesby,
                                      markettype: insurer?.markettype,
                                      isactive: true,
                                      otherinfo: insurer?.otherinfo,
                                      verticalids: insurer?.verticalids,
                                      bindtype: insurer?.bindtype,
                                      verticalid: insurer?.verticalid,
                                      insurer_is_type1:
                                        typeof insurer?.insurer_is_type1 ==
                                        "boolean"
                                          ? insurer?.insurer_is_type1
                                          : insurer?.markettype,
                                    });
                                  }
                                }}
                              />
                            </th>
                          </tr>
                        </Fragment>
                      );
                    })
                  ) : (
                    <tr />
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label className="col-sm-4 col-form-label">Hide Direct Billing</label>
            <div className="col-sm-8">
              <input
                className="form-control"
                id="chkActive"
                type="checkbox"
                onChange={(event) => {
                  const otherinfo = { ...insurer.otherinfo, hidedirectbilling: event.target.checked };
                  setInsurer((prevInsurer) => ({
                    ...prevInsurer,
                    otherinfo
                  })) ;
                }}
                checked={insurer?.otherinfo?.hidedirectbilling}
              />
            </div>
          </div>
          <div className="m-2" style={{ width: "10%", float: "right" }}>
            <Button
              style={{
                color: "white",
                height: "3.5vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 12,
                backgroundColor: theme.COLORS.secondary_skyblue,
                marginTop: 5,
                marginLeft: 10,
                marginBottom: 10,
                border: 0,
                width: "7vw",
                letterSpacing: 1,
              }}
              onClick={() => {
                insurer?.code ? onUpdateButtonClick() : onAddButtonClick();
              }}
            >
              {insurer?.code ? "Update" : "Add"}
            </Button>
          </div>
          <div className="m-2" style={{ width: "10%", float: "right" }}>
            <Button
              style={{
                color: "white",
                height: "3.5vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 12,
                backgroundColor: theme.COLORS.secondary_skyblue,
                marginTop: 5,
                marginLeft: 10,
                marginBottom: 10,
                border: 0,
                width: "7vw",
                letterSpacing: 1,
              }}
              onClick={() => {
                onCancelButtonClick(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </PerfectScrollbar>
  );
};

const InsurerContactItems = (props) => {
  const dispatch = useDispatch();
  let history = useNavigate();
  const insurers = useSelector(getDefaultInsurersListSelector);
  return (
    <div
      className="m-4"
      style={{
        fontFamily: "GibsonRegular",
        fontSize: "0.8vw",
        justifyContent: "center",
      }}
    >
      <table className="table table-sm">
        <thead>
          <tr>
            <th scope="col">Insurer Name</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          {insurers ? (
            insurers.map((item) => {
              return (
                <Fragment key={item.code}>
                  <tr scope="row" className="thead-light">
                    <th scope="row">{item.name}</th>
                    <th scope="row">
                      <Button
                        style={{
                          justifyContent: "center",
                          color: "white",
                          fontFamily: "GibsonRegular",
                          fontSize: 10,
                          backgroundColor: theme.COLORS.secondary_orange,
                          border: 0,
                          letterSpacing: 1,
                        }}
                        onClick={() => {
                          props.setInsurer(item);
                          dispatch(toggleAddInsurerModal(true));
                        }}
                      >
                        Edit Insurer
                      </Button>
                    </th>
                  </tr>
                </Fragment>
              );
            })
          ) : (
            <tr />
          )}
        </tbody>
      </table>
    </div>
  );
};

export default BrokerageInsurerAdminDashboard;
